/**
 * Object.prototype property names that must never be used as config keys.
 * Bare `obj[key]` lookups (and historically resolveConfigType) treat these as
 * inherited members; persisting one bricks the editor until fixed via API/DB.
 */
const RESERVED_CONFIG_KEYS = new Set(['__proto__', 'constructor', 'prototype', 'toString', 'valueOf', 'hasOwnProperty']);

/** True when `key` collides with an Object.prototype property name. */
export const isReservedConfigKey = (key: string): boolean => RESERVED_CONFIG_KEYS.has(key);

export const RESERVED_CONFIG_KEY_MESSAGE = 'This key name is reserved (conflicts with a built-in object property). Choose a different key.';
